const mutationToAction = {
  'emergencia/SOCKET_addEmergencia': 'medioPersonal/trackAndLoadEmergencia',
  'emergencia/SOCKET_ocultarEmergencia': 'medioPersonal/trackUnhiddenEmergencia',
  'emergencia/SOCKET_editEstadoEmergencia': 'medioPersonal/loadEditedEmergenciaStart',
  'emergencia/SOCKET_addRecursosEmergencia': 'medioPersonal/loadAddedRecursosDates',
  'emergencia/SOCKET_editRecursoEmergencia': 'medioPersonal/loadEditedRecursoDates',
  'emergencia/SOCKET_deleteEmergencia': 'medioPersonal/untrackActiveEmergencia',
}

const emergenciaPlugin = (store) => {
  store.subscribe((mutation) => {
    const action = mutationToAction[mutation.type]
    if (action) store.dispatch(action, mutation.payload)
  })
}

export default emergenciaPlugin
